import React from "react";
import 'react-toastify/dist/ReactToastify.css';
import { Navigate } from "react-router-dom";
//Authentication
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import ForgetNewPassword from "../pages/Authentication/ForgetNewPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ContactUs from "../pages/Landing/SaleNinja/ContactUs/ContactUs";
//profile 
import UserProfile from "../pages/Authentication/user-profile";
// subscripe
import PlanPackages from "../pages/PlanPricing/PlanPackages";
//all Report 
import EmployeeReport from "../pages/Report/EmployeeReport";
import ClientReport from "../pages/Report/ClientReport";
import NeverAttendedCall from "../pages/Report/NeverAttendedCall";
import NeverPickepReport from "../pages/Report/NeverPickepReport";
import CallHistoryReport from "../pages/Report/CallHistoryReport";
import RoleManagement from "../pages/Management/RoleManagement/RoleManagement";
import UserManagement from "../pages/Management/UserManagement/UserManagement";
import AppVersion from "../pages/Management/UserManagement/AppVersion";
import CallRecordingReport from "../pages/Report/CallRecordingReport";
import CallArchivesReport from "../pages/Report/CallArchivesReport";
import SuccessMsg from "../pages/AuthenticationInner/SuccessMessage/SuccessMsg";
import DashboardCallCrm from "../pages/DashboardCallCrm";
import InvoiceList from "../pages/Invoices/InvoiceList";
import VerifiedSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/VerifiedSuccessMsg";
import BasicLogout from "../pages/AuthenticationInner/Logout/BasicLogout";
import AddonPlan from "../pages/PlanPricing/AddonPlan";
import FuturePlan from "../pages/PlanPricing/FuturePlan";
import SubscriptionPlan from "../pages/PlanPricing/SubscriptionPlan";
import PaymentSuccessMsg from "../Components/Common/PaymentSuccessMsg";
import PaymentFailureMsg from "../Components/Common/PaymentFailureMsg";
import AlreadyVerifiedSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/AlreadyVerifiedSuccessMsg";
import NinjaLogo from "../pages/Logo/NinjaLogo";
import Twitter from "../pages/Logo/twitter";
import Linkedin from "../pages/Logo/Linkedin";
import Facebook from "../pages/Logo/Facebook";
import Insta from "../pages/Logo/insta";
import ResetPassword from "../pages/Logo/ResetPassword";
import Team from "../pages/team/Team";
import SubExpired from "../Components/Common/subExpired";
import ThemeProfile from "../pages/Logo/themeProfile";
import ForgetEmployeeNewPassword from "../pages/Authentication/ForgetEmployeePassword";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";
import ErrorFiveHundred from "../pages/AuthenticationInner/Errors/Error500";
import SalesNinjaLogo from "../pages/Logo/salesNinjaLogo";
import SuperAdmin from "../pages/Authentication/Super-Admin";
import SuperAdminDashboard from "../pages/SuperAdminDashboard";
import SetPerformance from "../pages/AgentPerformance/SetPerformanceReport";
import ViewLeaderboard from "../pages/AgentPerformance/ViewLeaderboard";
import { TopCallersReport, TopConnectedReport, TopDialersReport, TopDurationReport } from "../pages/Report/AllTopReport";
import ExcludeNumber from "../pages/ExcludeNumber/ExcludeNumber";
import StorageManagement from "../pages/StorageManagement/StorageManagement";
import Storage from "../pages/StorageManagement/Storage";
import LeadDetails from "../Components/Common/LeadDetails";
import LeadList from "../pages/LeadManagement/Leads/LeadList/LeadList";

import EditLeadForm from "../pages/LeadManagement/Leads/Leads/EditLead";
import AddLeadForm from "../pages/LeadManagement/Leads/Leads/AddLead";
import BulkOperation from "../pages/LeadManagement/Leads/BulkOperation/BulkOperation";
import LeadStatusReport from "../pages/LeadManagement/Leads/LeadStatusReport/LeadStatusReport";
import NotContactedLead from "../pages/LeadManagement/Leads/NotContactedLeadReport/NotContactedLead";
import ConsolidatedReport from "../pages/Consolidate report/ConsolidatedReport";
import LeadChangeStatus from "../pages/LeadManagement/Leads/LeadStatusReport/LeadStatusCrud/LeadChangeStatus";
import QuotationManagement from "../pages/QuotationManagement/QuotationManagement";
import ReportAnalytics from "../pages/LeadManagement/Analytics/ReportAnalytics";
import CallSummaryAnalysis from "../pages/CallAnalysis/CallSummaryAnalysis";
import DetailedAnalysis from "../pages/CallAnalysis/DetailedAnalysis";
import Operation from "antd/es/transfer/operation";
import AiAgent from "../AiAgent/AiAgent";
import UnqiueClientReport from "../pages/Report/UniqueClientReport";
import AiAgent1 from "../AIAgent1/AiAgent1";
import EmployeeWiseClientReport from "../pages/Report/employeeWiseClientReport";
import TeamWiseReport from "../pages/Report/TeamWiseReport";

import UnauthorizedToken from "../AIAgent1/UnAuthorisedPage";
import ValidToken from "../AIAgent1/ValidToken";




const authProtectedRoutes = [

  //  plan and Pricing
  { path: "/expired-plan", component: <SubExpired /> },
  { path: "/admin-dashboard", component: <SuperAdminDashboard /> },
  { path: "/dashboard", component: <DashboardCallCrm /> },

  //  plan and Pricing
  { path: "/planPackage", component: <PlanPackages /> },

  //Invoices
  { path: "/invoices", component: <InvoiceList /> },
  { path: "/subscription-plan", component: <SubscriptionPlan /> },
  { path: "/addon-plan", component: <AddonPlan /> },
  { path: "/future-plan", component: <FuturePlan /> },

  //TEAM MANAGEMENT ROUTE
  { path: "/team-Management", component: <Team /> },

  //EMPLOYEE MANAGEMENT ROUTE
  { path: "/employee-Management", component: <UserManagement /> },
  { path: "/app-version", component: <AppVersion /> },
  // EMPLOYEE MANAGEMENT

  //Role Management ROUTE
  { path: "/role-management", component: <RoleManagement /> },


  // report section  route
   { path: "/team-wise-report", component: <TeamWiseReport /> },
   { path: "/client-wise-report", component: <EmployeeWiseClientReport /> },
  { path: "/unique-client-report", component: <UnqiueClientReport /> },
  { path: "/call-report", component: <CallHistoryReport /> },
  { path: "/employee-report", component: <EmployeeReport /> },
  { path: "/client-report", component: <ClientReport /> },
  { path: "/neverAttended-report", component: <NeverAttendedCall /> },
  { path: "/notPickeped-report", component: <NeverPickepReport /> },
  { path: "/consolidated-report", component: <ConsolidatedReport /> },
  // report section


  //  call Recording
  { path: "/call-recordings", component: <CallRecordingReport /> },
  { path: "/call-archives", component: <CallArchivesReport /> },


  // Performance metrics route
  { path: "/topCallers-report", component: <TopCallersReport /> },
  { path: "/topDialers-report", component: <TopDialersReport /> },
  { path: "/topCallDuration-report", component: <TopDurationReport /> },
  { path: "/topConnected-report", component: <TopConnectedReport /> },
  { path: "/excludeNumber-report", component: <ExcludeNumber /> },
  // Performance metrics


  { path: "/storage-management", component: <Storage /> },
  { path: "/storage-management", component: <StorageManagement /> },


  // LEAD MANAGEMENT ROUTES 
  { path: "/leads", component: <LeadList /> },
  { path: "/add-Lead", component: <AddLeadForm /> },
  { path: "/edit-Lead", component: <EditLeadForm /> },

  /* BULK OPERATION */
  { path: "/Bulk-Operation", component: <BulkOperation /> },

  // REPORT ANALYTICS
  { path: "/Report-Analytics", component: <ReportAnalytics /> },

  // LEAD STATUS REPORT
  { path: "/Lead-Status-Report", component: <LeadStatusReport /> },
  { path: "/Lead-Change-Status", component: <LeadChangeStatus /> },
  { path: "/Not-Contacted-Leads", component: <NotContactedLead /> },
  

  
  { path: "/Lead-Details", component: <LeadDetails /> },
  // LEAD MANAGEMENT ROUTES


  // Call Analysis route
  { path: "Call-Summary-Analysis", component: <CallSummaryAnalysis /> },
  { path: "Detailed-Analysis", component: <DetailedAnalysis /> },




  //User Profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/profile/update/:update_type", component: <UserProfile /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },

  // Agent Performance Report
  // { path: "/agent-performance", component: <AgentTable /> },
  { path: "/set-performance", component: <SetPerformance /> },
  { path: "/view-leaderboard", component: <ViewLeaderboard /> },


  // Qoutation-Management
  { path: "/quotation-management", component: <QuotationManagement /> },
];


const publicRoutes = [
  { path: "/", component: <Login /> },
  { path: "/admin-login", component: <SuperAdmin /> },
  { path: "/contact", component: <ContactUs /> },
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/organization-create-password", component: <ForgetNewPassword /> },
  { path: "/employee-create-password", component: <ForgetEmployeeNewPassword /> },

  { path: "/register", component: <Register /> },
  { path: "/auth-logout", component: <BasicLogout /> },
  //AuthenticationInner pages
  { path: "/auth-success-msg", component: <SuccessMsg /> },
  // payment routes 
  { path: "/payment-success", component: <PaymentSuccessMsg /> },
  { path: "/payment-failure", component: <PaymentFailureMsg /> },
  { path: "/verify-organization", component: <VerifiedSuccessMsg /> },
  { path: "/already-verify-organization", component: <AlreadyVerifiedSuccessMsg /> },
  // logo and twitter facebook insta,

  { path: "/logo-theme", component: <ThemeProfile /> },
  { path: "/logo-sales-ninja", component: <NinjaLogo /> },
  { path: "/sales-ninja-email-logo", component: <SalesNinjaLogo /> },
  { path: "/logo-twitter", component: <Twitter /> },
  { path: "/logo-facebook", component: <Facebook /> },


  { path: "/logo-instagram", component: <Insta /> },
  { path: "/logo-linkedin", component: <Linkedin /> },
  { path: "/logo-resetpass", component: <ResetPassword /> },

  { path: "/server-error", component: <ErrorFiveHundred /> },
  { path: "/auth-offline", component: <Offlinepage /> },
  {path: "/ai-agent-new" , component:<AiAgent/>},
  {path: "/ai-agent" , component:<AiAgent1/>},
  {path: "/valid-token" , component:<ValidToken/>},
  {path: "/unauthorised" , component:<UnauthorizedToken/>},
];



export { authProtectedRoutes, publicRoutes };